<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created () {
    if (this.$store.state.asadmin === 1) {
      window.ybug_settings = { id: '1r5whqtts2rv7p3kt7yf' }
      const ybug = document.createElement('script'); ybug.type = 'text/javascript'; ybug.async = true
      ybug.src = 'https://widget.ybug.io/button/' + window.ybug_settings.id + '.js'
      const s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ybug, s)
    }
  }
}
</script>
<style>
body {
  background-color: white;
}
</style>
